const IncentiveClaimFormSection = ({ children, language = false }) => {
  return (
    <div className="bg-white p-6 rounded shadow-md mx-auto">
      <h2 className="text-lg font-semibold text-white nav-bg p-3 rounded-t -m-6 mb-4">
        {language
          ? "प्रोत्साहन दावे के लिए आवेदन करें"
          : "Apply for Incentive Claim"}
      </h2>
      {children}
    </div>
  );
};

export default IncentiveClaimFormSection;
